<mat-sidenav-container class="shell-container">
    <mat-sidenav class="sidenav" mode="side" opened>
        <div class="brand">
            <img
                class="brand-logo"
                alt="Rymax Admin home"
                height="28"
                src="../../assets/images/logos/mock-brand-logo.svg"
            />
            <span class="brand-text label-2">Rymax Admin</span>
        </div>

        <mat-nav-list class="nav-list">
            @for (link of links; track link.label) {
                <a mat-list-item routerLinkActive="active" [routerLink]="link.path" class="nav-item">
                    <mat-icon matListItemIcon class="nav-icon">{{ link.icon }}</mat-icon>
                    <span matListItemTitle class="nav-label body-0">{{ link.label }}</span>
                </a>
            }
        </mat-nav-list>

        <div class="sidebar-footer">
            <button mat-button class="user-button" (click)="onLogout()">
                <mat-icon class="user-icon">logout</mat-icon>
                <span class="user-label body-0">Logout</span>
            </button>
        </div>
    </mat-sidenav>

    <mat-sidenav-content class="content-pane">
        <main class="main-content">
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>
<lib-ui-blocker-overlay />
